export const keepAliveConfig = {
  CompanyContactMenu: { to: ['CompanyDetail'] }, // 企業通訊錄
  MembersManage: { to: ['MemberProfile'] }, // 會員管理
  MemberLevelSetting: { to: ['MemberLevelEdit'] }, // 會員等級設定
  MemberCardSetting: { to: ['MemberCardEdit'] }, // 會員卡面設定
  TagsSetting: { to: ['TagsAdvancedSearch'] }, // 標籤設定
  EventMarketingList: { to: ['EventMarketingEdit'] }, // 事件行銷列表
  TrackingLinkManagement: { to: ['EditTrackingLink'] }, // 追蹤連結管理
  MemberCenterBulletinList: { to: ['MemberCenterBulletinEdit'] }, // 會員中心佈告欄
  MemberCenterBulletinDetailList: { to: ['MemberCenterBulletinDetailEdit'] }, // 佈告資訊頁列表
  ProgressNotificationTargetTemplateList: { to: ['ProgressNotificationTargetTemplateEdit'] }, // 通知對象範本
  ProgressNotificationContentTemplateList: { to: ['ProgressNotificationContentTemplateEdit'] }, // 通知內容範本
  ServiceSetting: { to: ['CreateReservationService'] }, // 服務項目設定
  ResourceSetting: { to: ['ResourceEdit'] }, // 設備管理
  SalesActivity: { to: ['SalesActivityEdit'] }, // 銷售回饋活動
  ClassTicketSetting: { to: ['CreateClassTicket'] }, // 堂票設定
  ClassTicketRecord: { to: ['MemberProfile'] }, // 堂票紀錄列表
  OtherPageSetting: { to: ['OtherPageEdit'] }, // 其他頁面設定
  EcommerceProductSetting: { to: ['ProductModify'] }, // 商品項目設定
  OrderManage: { to: ['OrderDetail'] }, // 訂單管理
  RewardContentSetting: { to: ['RewardManage'] }, // 抽獎內容設定
  CouponSetting: { to: ['CouponCreate'] }, // 使用券設定
  CouponExchangeSetting: { to: ['CouponExchangeSerial', 'CouponExchangeCreate'] }, // 兌換券設定
  OpentixCouponList: { to: ['OpentixCouponEdit'] }, // OPENTIX 優惠券設定
  MemberShopPointExchangeCenter: { to: ['MemberShopProductExchangeEdit'] }, // 點數兌換中心
  MemberShopPointExchangeRecord: { to: ['MemberShopPointExchangeRecordDetail'] }, // 點數兌換紀錄
  MemberShopProductSettings: { to: ['MemberShopProductEdit'] }, // 商城商品設定
  MemberShopOrderManage: { to: ['MemberShopOrderDetail'] }, // 商城訂單管理
  MemberShopGiveaway: { to: ['MemberShopGiveawayEdit'] }, // 商城贈品活動
  MemberShopFeedbackActivity: { to: ['MemberShopFeedbackActivityEdit'] }, // 商城回饋活動
  externalTransactionActivity: { to: ['ExternalTransactionActivityEdit'] }, // 回饋活動設定
  RewardActivityList: { to: ['SerialActivityRewardRecord', 'SerialCodeManagement', 'RewardActivityEdit'] }, // 序號登錄活動
  CustomOrderStatus: { to: ['EditCustomOrderStatusSetting'] }, // 自定義訂單狀態
}
